import {
  Box,
  ButtonBase,
  FormControl,
  InputBase,
  MenuItem,
  Select,
} from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import clsx from "clsx";
import React from "react";
import { Vibe } from "redmond";
import styles from "./styles.module.scss";

export interface VibePickerProps {
  vibes: Vibe[];
  selectedVibeName?: string;
  isMobile: boolean;
  isScrolled?: boolean;
  onChange: (vibeName: string) => void;
}

export const VibePicker: React.FC<VibePickerProps> = ({
  vibes,
  selectedVibeName,
  isMobile,
  isScrolled,
  onChange,
}) => {
  if (!vibes.length) {
    return null;
  }

  const resolvedSelectedVibeName = selectedVibeName ?? vibes[0].vibeName;
  const selectedVibe = vibes.find(
    (vibe) => vibe.vibeName === resolvedSelectedVibeName
  );
  const resolvedSelectedLabel =
    selectedVibe?.basicVibe.filterName ?? resolvedSelectedVibeName;

  const InlineChevron = () => (
    <ChevronLeftIcon className={styles.icon} />
  );

  if (isMobile) {
    return (
      <Box className={clsx(styles.root, styles.mobile)}>
        <FormControl className={styles.wrap}>
          <Select
            value={resolvedSelectedVibeName}
            onChange={(event) => onChange(String(event.target.value))}
            className={clsx(styles.select, {
              [styles.scrolled]: isScrolled,
            })}
            classes={{ select: styles.selectButton }}
            renderValue={() => (
              <span className={styles.value}>
                <span>{resolvedSelectedLabel}</span>
                <InlineChevron />
              </span>
            )}
            IconComponent={() => null}
            MenuProps={{
              anchorOrigin: { vertical: "bottom", horizontal: "left" },
              transformOrigin: { vertical: "top", horizontal: "left" },
              getContentAnchorEl: null,
            }}
            input={<InputBase className={styles.selectInput} />}
            inputProps={{ "aria-label": "Select a vibe" }}
          >
            {vibes.map((vibe) => (
              <MenuItem key={vibe.vibeName} value={vibe.vibeName}>
                {vibe.basicVibe.filterName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    );
  }

  return (
    <Box className={styles.root}>
      <Box className={styles.list}>
        {vibes.map((vibe) => {
          const isSelected = vibe.vibeName === resolvedSelectedVibeName;
          return (
            <ButtonBase
              key={vibe.vibeName}
              className={clsx(styles.button, {
                [styles.selected]: isSelected,
              })}
              onClick={() => onChange(vibe.vibeName)}
              aria-pressed={isSelected}
            >
              {vibe.basicVibe.filterName}
            </ButtonBase>
          );
        })}
      </Box>
    </Box>
  );
};
